<script lang="ts">
	import type { BoutInDepthStats } from '../types';
	import InDepthColumn from './InDepthColumn.svelte';

	export let blue: BoutInDepthStats;
	export let red: BoutInDepthStats;
</script>

<div class="d-flex mt-4">
	<div class="sidebar d-none d-sm-block">
		<h3 class="py-2 mb-0">&nbsp;</h3>
		<table class="py-4">
			<thead>
				<tr>
					<td class="pt-3 pb-2">&nbsp;</td>
				</tr>
			</thead>
			<tbody>
				{#each ['Thrown', 'Landed', 'Missed'] as statName}
					<tr class="group-header">
						<td colspan="2"><strong>Punches {statName}</strong></td>
					</tr>

					<tr>
						<td />
						<td class="pt-3">From Distance</td>
					</tr>

					<tr>
						<td />
						<td class="pb-3">From Clinch</td>
					</tr>
				{/each}
			</tbody>
		</table>
	</div>
	<InDepthColumn stats={blue} corner="blue" />

	<InDepthColumn stats={red} corner="red" />
</div>

<style>
	.sidebar {
		width: 20%;
	}
</style>
